import { ProductBySlugQuery_productBySlug_Product } from "@/Apollo/schema";
import { isNil } from "@/common/utils/value.utils";
import { DeliveryLocation } from "@/features/delivery-location/components/DeliveryLocation";
import { useDeliveryLocation } from "@/features/delivery-location/hooks/useDeliveryLocation";
import { ProductDeliveryOptionItem } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemListSkeleton } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemListSkeleton";
import { useProductDeliveryOptionItemList } from "@/features/product-delivery-options/hooks/useProductDeliveryOptionItemList";

type ProductDeliveryOptionItemListProps = {
  product: ProductBySlugQuery_productBySlug_Product;
};

export const ProductDeliveryOptionItemList = ({
  product,
}: ProductDeliveryOptionItemListProps) => {
  const { address } = useDeliveryLocation();

  const { options, loading } = useProductDeliveryOptionItemList(
    product.id,
    address
  );

  if (loading && !options) {
    return <ProductDeliveryOptionItemListSkeleton />;
  }

  if (!options?.length) {
    return null;
  }

  return (
    <div
      data-testid="pdp.shipping.options"
      className="flex flex-col divide-y divide-grey-300 border border-grey-300"
    >
      <DeliveryLocation variant="pdp" className="p-4" />
      {options?.map(option => {
        const noPrice = isNil(option.price);

        if (noPrice) {
          return null;
        }

        return (
          <ProductDeliveryOptionItem
            key={`${option.shippingMethod}-${option.shippingProvider}`}
            product={product}
            option={option}
            loading={loading}
            defaultAddress={address}
          />
        );
      })}
    </div>
  );
};
